import {BasketItemModel} from '@features/basket/interfaces';

export const getBasketSelectedCount = (items: BasketItemModel[]) => {
    const selectedCount = items.filter((item) => item.checked).length;

    return {selectedCount};
}